import React, { Component } from "react";
import reactCSS from "reactcss";
import PropTypes from "prop-types";
import MaskedInput from "react-text-mask";
import { If } from "components/support";

import { colors } from "assets";

import Icon from "material-ui-next/Icon";

import "../index.css";

class TextField extends Component {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    defaultValue: PropTypes.any,
    //disabled: PropTypes.bool,
    fullWidth: PropTypes.bool,
    fieldWidth: PropTypes.number,
    label: PropTypes.string,
    id: PropTypes.string,
    multiLine: PropTypes.bool,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    onKeyDown: PropTypes.func,
    rows: PropTypes.number,
    type: PropTypes.string,
    value: PropTypes.any,
    errorText: PropTypes.string,
    allowClear: PropTypes.bool,
    // TODO: Remove Material-UI props
    hintText: PropTypes.node,
    floatingLabelText: PropTypes.node,
    underlineShow: PropTypes.any,
    underlineStyle: PropTypes.any,
    labelStyle: PropTypes.any,
    maskPattern: PropTypes.array,
    focus: PropTypes.bool
  };

  static defaultProps = {
    minLength: 0,
    maxLength: 255,
    allowClear: false,
    disabled: false,
    multiLine: false,
    fullWidth: false,
    fieldWidth: 256,
    type: "text",
    rows: 1,
    errorText: "",
    value: "",
    placeholder: "",
    onChange: () => {},
    onKeyDown: () => {},
    focus: false
  };

  static styles = (props, state) =>
    reactCSS(
      {
        isFocused: {
          input: {
            color: colors.text.normal,
            borderColor: props.transparent ? "transparent" : colors.text.normal
          },
          label: {
            color: colors.text.normal
          }
        },
        disabled: {
          field: {
            opacity: props.transparent || 0.6
          },
          input: {
            cursor: props.transparent || "not-allowed",
            background: props.transparent ? "transparent" : "#F3F3F3"
          }
        },
        error: {
          element: {
            border: props.transparent
              ? "1px solid transparent"
              : "1px solid #FF0014"
          },
          input: {
            color: "#FF0014"
          },
          label: {
            color: "#FF0014"
          }
        },
        default: {
          field: {
            display: "inline-block",
            width: props.fullWidth ? "100%" : props.fieldWidth,
            margin: "12px 0 0",
            boxSizing: "border-box"
          },
          element: {
            width: props.fullWidth ? "100%" : props.fieldWidth,
            borderRadius: 3,
            borderColor: props.transparent ? "transparent" : "#CCC",
            border: props.transparent
              ? "1px solid transparent"
              : "1px solid #CCC",
            boxSizing: "border-box",
            position: "relative"
          },
          input: {
            background: "transparent",
            outline: "none",
            boxSizing: "border-box",
            width: props.allowClear ? "calc(100% - 32px)" : "100%",
            height: "30px",
            border: "none",
            fontFamily: props.transparent ? props.font : "Source Sans Pro",
            fontSize: props.transparent ? 20 : 15,
            padding: props.transparent || 6,
            resize: "none"
          },
          label: {
            width: "100%",
            fontFamily: "Source Sans Pro",
            fontSize: "0.8em",
            fontWeight: "bold",
            cursor: "pointer",
            color: "#222"
          },
          errorText: {
            color: "#FF0014",
            marginTop: 0,
            paddingTop: "0.4em",
            fontSize: "0.8em",
            fontFamily: "Source Sans Pro",
            whiteSpace: "pre-line"
          },
          clearButton: {
            width: "32px",
            height: "32px",
            position: "absolute",
            right: 2,
            bottom: 2,
            zIndex: 2,
            cursor: "pointer"
          }
        },
        multiLine: {
          input: {
            height: "inherit"
          }
        },
        noMargin: {
          field: {
            margin: 0
          }
        }
      },
      props,
      state
    );

  constructor(props) {
    super(props);

    this.state = {
      value: this.props.value || this.props.defaultValue || "",
      isFocused: this.props.focus || false,
      error: false
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.value !== this.props.value) {
      this.setValue(nextProps.value);
    }
    if (nextProps.errorText === "") {
      this.setError(false);
    } else {
      this.setError(true);
    }
  }

  getLabel() {
    return (
      this.props.label ||
      this.props.floatingLabelText ||
      this.props.hintText ||
      false
    );
  }

  getValue() {
    const value = !!this.props.value ? this.props.value : this.state.value;
    return value;
  }

  getElement(styles) {
    if (this.props.maskPattern) {
      return (
        <MaskedInput
          ref={input => {
            if (input) {
              this.input = input.inputElement;
            }
          }}
          required={this.props.required}
          type="text"
          mask={this.props.maskPattern}
          onChange={event => {
            if (this.props.onChange) {
              this.props.onChange(event, event.target.value);
            }
          }}
          value={this.getValue()}
          style={styles.input}
          disabled={this.props.disabled}
        />
      );
    }

    if (this.props.multiLine) {
      return (
        <textarea
          ref={input => {
            this.input = input;
          }}
          required={this.props.required}
          value={this.getValue()}
          onChange={this.handleOnChange}
          onFocus={this.handleOnFocus}
          onBlur={this.handleOnBlur}
          onClick={() =>
            !this.props.disabled && this.props.onClick && this.props.onClick()
          }
          className={this.props.className || ""}
          style={styles.input}
          disabled={this.props.disabled}
          maxLength={this.props.multilineMaxLength}
        />
      );
    } else {
      return (
        <input
          minLength={this.props.minLength}
          required={this.props.required}
          disabled={this.props.disabled}
          type={this.props.type}
          value={this.getValue()}
          onChange={this.handleOnChange}
          onFocus={this.handleOnFocus}
          onBlur={this.handleOnBlur}
          onClick={() =>
            !this.props.disabled && this.props.onClick && this.props.onClick()
          }
          onKeyDown={this.props.onKeyDown}
          className={this.props.className || ""}
          style={{ ...styles.input, ...this.props.inputStyle }}
          placeholder={this.props.placeholder}
          maxLength={this.props.maxLength}
          ref={input => {
            this.input = input;
          }}
        />
      );
    }
  }

  async setValue(value) {
    this.setState({
      value
    });
  }

  setIsFocused(value) {
    this.setState({
      isFocused: value
    });
  }

  setError(value) {
    this.setState({
      error: value
    });
  }

  handleOnChange = event => {
    if (this.props.disabled) {
      return;
    }

    if (this.props.onChange) {
      this.props.onChange(event, event.target.value);
    } else {
      this.setValue(event.target.value);
    }
  };

  handleOnFocus = event => {
    if (this.props.disabled) {
      return;
    }

    this.setIsFocused(true);

    if (this.props.onFocus) {
      this.props.onFocus(event);
    }
  };

  handleOnBlur = event => {
    if (this.props.disabled) {
      return;
    }

    this.setIsFocused(false);

    if (this.props.onBlur) {
      this.props.onBlur(event);
    }
  };

  handleClearButton = async event => {
    if (this.props.onChange) {
      this.props.onChange(event, "");
    } else {
      await this.setValue("");
    }
  };

  handleLabelClick = () => {
    if (this.input) {
      this.input.focus();
    }
  };

  componentDidMount = () => {
    if (this.input && this.props.focus) {
      this.input.focus();
    }
  };

  render() {
    const textFieldClassNames = ["text-field"]
      .concat([!!this.props.errorText ? "text-field--invalid" : ""])
      .join(" ");
    const styles = TextField.styles(this.props, this.state);
    return (
      <div
        className={textFieldClassNames}
        style={{ ...styles.field, ...this.props.style }}
      >
        <div style={{ display: "flex", marginBottom: 4 }}>
          <label
            onClick={this.handleLabelClick}
            style={{ flex: "1", marginRight: 8 }}
          >
            <If test={this.getLabel()}>
              <div className="text-field--label" style={styles.label}>
                {this.getLabel()}
              </div>
            </If>
          </label>
          <div style={{ alignSelf: "flex-end" }}>{this.props.rightLabel}</div>
        </div>
        <div className="text-field--element" style={styles.element}>
          {this.getElement(styles)}
          {this.props.allowClear && this.getValue().length > 0 && (
            <div
              className="text-field--clear-button"
              onClick={this.handleClearButton}
              style={styles.clearButton}
            >
              <Icon style={{ paddingTop: 4, fontSize: "1.9em" }}>close</Icon>
            </div>
          )}
        </div>
        {this.props.errorText.length > 0 && (
          <p className="error-text-message" style={styles.errorText}>
            {this.props.errorText}
          </p>
        )}
      </div>
    );
  }
}

export default TextField;



// WEBPACK FOOTER //
// ./src/components/support/text-field/index.jsx